import React, { useState, useEffect, useRef } from 'react';
import {  get_usr_info_by_email, get_devices_info, save_new_issue, load_issues, load_usage_timeline, get_issue_full, get_steam_licenses, get_contents_exclusive, add_license_stem, delete_license_stem, update_license_stem } from '../../../utils/services';
import './Email_info.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Modal_proyectos from '../../menus/Modal';
import User_header from './User_header';
import Device_header from './Device_header';
import { motion, AnimatePresence } from 'framer-motion';
import Ticket_panel from './Ticket_panel';
import Training_ticket_panel from './Training_ticket_panel';
import MiniStatusBar from './MiniStatusBar';
import { Dropdown } from 'react-bootstrap';
import {
  canCreateAnyTicket,
  canCreateSupportTicket,
  canCreateTrainingTicket,
} from '../../../utils/helpdesk_permissions';

/**
 * Permite agregar anotaciones de soporte a email y asociar TOMi8 a un email especifico.
 * @param {*} param0 
 * @returns 
 */
const Email_info = ({usr_id, permission, usr_name}) => {

  const token = localStorage.getItem("token");
  const [listofissues, setIssues] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loaded, setLoaded] = useState(false);
  const [serialInput, setserialInput] = useState("");
  const [name, setName] = useState("");
  const [packages, setPackages] = useState([]);
  const [showRemoteSupport, setShowRemoteSupport] = useState(false);
  const [item_status, setitem_status] = useState("");
  const [model, setModel] = useState("");
  const [manufactured_date, setManufactured_date] = useState("");
  const [dasboard_link, setdasboard_link] = useState("");
  const [FrogedId, setFrogedId] = useState('');
  const [issue_updating_id, setissue_updating_id] = useState(null);
  const [activeIssueType, setActiveIssueType] = useState(0);
  const [warranty_covered, setwarranty_covered] = useState("");
  const [mode, setMode] = useState("");
  const navigate = useNavigate();
  const [updatingAnnotation, setUpdatingAnnotation] = useState(false);
  const email_url = searchParams.get("email");
  const serial_url = searchParams.get("serial");
  const case_id = searchParams.get("case_id");
  // Proyecto desde el que se abrió el serial (lo manda el dashboard del lab en el link al
  // helpdesk). "Ver estadísticas" abre el dashboard en ESE proyecto —al que el usuario sí
  // tiene acceso— en vez del Global (104, solo-interno). Si no llega, cae al 104 por defecto.
  const project_url = searchParams.get("project");
  const [licenses, setLicenses] = useState([]);
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [showEditLicenseModal, setShowEditLicenseModal] = useState(false);
  const [contentsList, setContentsList] = useState([]);
  const [selectedContentId, setSelectedContentId] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [editingLicense, setEditingLicense] = useState(null);
  const [ticketTypeFilter, setTicketTypeFilter] = useState('all');
  const [usageSyncGroups, setUsageSyncGroups] = useState([]);
  const [expandedUsageClusters, setExpandedUsageClusters] = useState(() => new Set());
 
  const shouldShowRemoteSupportSection = (devicePackages) => {
    const touchDriverPackage = devicePackages.find(
      (pkg) => pkg.name === "com.tomi.t8_touch_driver"
    );
    const currentVersion = Number(touchDriverPackage?.current);
    return Number.isFinite(currentVersion) && currentVersion > 200;
  };

  const resetHelpdeskState = () => {
    setLoaded(false);
    setserialInput("");
    setMode("");
    setName("");
    setPackages([]);
    setShowRemoteSupport(false);
    setitem_status("");
    setModel("");
    setManufactured_date("");
    setdasboard_link("");
    setFrogedId("");
    setissue_updating_id(null);
    setActiveIssueType(0);
    setwarranty_covered("");
    setUpdatingAnnotation(false);
    setIssues([]);
    setUsageSyncGroups([]);
    setExpandedUsageClusters(new Set());
    setLicenses([]);
    setTicketTypeFilter('all');
  };

  const isDeviceAlreadyLoaded = () =>
    loaded &&
    ((serial_url && mode === "hw" && serialInput === serial_url) ||
      (email_url && mode === "sw" && serialInput === email_url));

  const openIssuePanel = (issueId, issueType = null) => {
    const normalizedId = Number(issueId);
    const resolvedId = Number.isNaN(normalizedId) ? issueId : normalizedId;
    setissue_updating_id(resolvedId);
    if (issueType !== null) {
      setActiveIssueType(Number(issueType) === 1 ? 1 : 0);
    }
    setUpdatingAnnotation(true);
  };

  const setCaseIdInUrl = (issueId) => {
    const next = new URLSearchParams(searchParams);
    next.set("case_id", String(issueId));
    setSearchParams(next);
  };

  const removeCaseIdFromUrl = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("case_id");
    setSearchParams(next);
  };

  const closeIssuePanel = () => {
    removeCaseIdFromUrl();
    if (mode === "hw" && serialInput) {
      loadIssues(serialInput, "hw");
    } else if (mode === "sw" && serialInput) {
      loadIssues(serialInput, "sw");
    } else {
      setLoaded(false);
    }
  };

  useEffect(() => {
    if (!serial_url && !email_url && !case_id) {
      resetHelpdeskState();
    }
  }, [serial_url, email_url, case_id]);

  useEffect(() => {
    if (!case_id && updatingAnnotation) {
      setissue_updating_id(null);
      setActiveIssueType(0);
      setUpdatingAnnotation(false);
    }
  }, [case_id]);

  useEffect(() => {
    if (email_url !== null) {
      setMode("sw");
      setserialInput(email_url);
      handleFindBtSW(email_url);
    }
  }, [email_url]); 

  useEffect(() => {
    if (serial_url !== null) {
      setMode("hw");
      setserialInput(serial_url);
      handleFindBtHW(serial_url);
    }
  }, [serial_url]); 

  useEffect(() => {
    if (case_id === null) {
      return;
    }

    if (isDeviceAlreadyLoaded()) {
      const ticket = listofissues.find(
        (t) => t.id === case_id || Number(t.id) === Number(case_id)
      );
      openIssuePanel(
        case_id,
        ticket ? ticket.issue_type : null
      );
      return;
    }

    async function fetchCaseInfo(caseId) {
      try {
        const issueData = await get_issue_full(token, caseId);
        if (issueData === "INVALID") {
          navigate("/");
          return;
        }

        const issueInfo = issueData?.issue_info?.[0];

        if (!issueInfo) {
          alert(`Ticket ${caseId} no encontrado.`);
          return;
        }

        openIssuePanel(caseId, issueInfo.issue_type ?? 0);

        const serialValue = issueInfo.serial_num ? String(issueInfo.serial_num).trim() : "";
        const emailValue = issueInfo.email ? String(issueInfo.email).trim() : "";

        if (serialValue) {
          setMode("hw");
          setserialInput(serialValue);
          handleFindBtHW(serialValue);
          loadLicenses(serialValue);
        } else if (emailValue) {
          setMode("sw");
          setserialInput(emailValue);
          handleFindBtSW(emailValue);
        } else {
          setLoaded(true);
        }
      } catch (error) {
        console.error("Error cargando el ticket:", error);
        alert("No se pudo cargar el ticket solicitado.");
      }
    }

    fetchCaseInfo(case_id);
  }, [case_id]);

  
 

 const handleFindBt = (searchWord) => {
    if (searchWord.includes("@")) {
      navigate('/helpdesk?email=' + searchWord);
    } else {
      navigate('/helpdesk?serial=' + searchWord);
    }
  };

  const handleFindBtSW = (email) => {

    async function fetchEmailInfo(theEmail) {
      
      const deviceMessages = await get_usr_info_by_email(token, theEmail);
      if (deviceMessages==="INVALID"){
        navigate("/");
      } else if (deviceMessages==="NOT_FOUND"){
        if (permission === "1")
          alert("Email " + theEmail + " no encontrado.");
        else
          alert("Email " + theEmail + " no encontrado. O no tienes acceso a este serial.");
      } else {
        if (!(deviceMessages[0].email)) {
          alert("No existe el Email");
          return;
        }

       setName (deviceMessages[0].name);
       setFrogedId (deviceMessages[0].froged_id);
       setShowRemoteSupport(false);
       setUsageSyncGroups([]);
       setExpandedUsageClusters(new Set());
       setLoaded(true);
       loadIssues(theEmail, "sw");

     }
    }

    fetchEmailInfo(email );
  };

  const getColorForId = (id) => {
    const hue = (id * 41) % 360;
    return `hsl(${hue}, 60%, 50%)`; 
  };

  const loadLicenses = (serial) => {
    async function fetchLicenses(theSerial) {
      const licensesData = await get_steam_licenses(theSerial);
      if (licensesData && licensesData.licenses) {
        setLicenses(licensesData.licenses);
      } else {
        setLicenses([]);
      }
    }
    fetchLicenses(serial);
  };

  const handleFindBtHW = (serial) => {
      setShowRemoteSupport(false);
  
   
      async function fetchGetDevice(theSerial) {
        
      
        const deviceMessages = await get_devices_info(token, theSerial);
        if (deviceMessages==="INVALID"){
          navigate("/");
        } else if (deviceMessages==="NOT_FOUND"){
          if (permission === "1")
            alert("Serial " + theSerial + " no encontrado.");
          else
            alert("Serial " + theSerial + " no encontrado. O no tienes acceso a este serial.");
        }else{
  
          
          if (!(deviceMessages[0].model)) {
            alert("No existe el serial");
            return;
          }
  
          setModel (deviceMessages[0].model);
          setManufactured_date (deviceMessages[0].manufactured_date);
          setitem_status (deviceMessages[0].item_status);
          setwarranty_covered (deviceMessages[0].warranty_covered);
          setName (deviceMessages[0].usr_name);
          // "Ver estadísticas" abre en pestaña nueva el dashboard del lab embebido en el admin
          // (Project_admin), acotado a este TOMi, en el PROYECTO desde el que se abrió el serial
          // (project_url) para respetar permisos; si no vino, cae al 104 (Global, solo-interno).
          // Project_admin reenvía el serial al iframe y el lab aterriza en "Uso TOMi" filtrado.
          // Ruta relativa → sirve en dev y prod.
          setdasboard_link("/project?id=" + (project_url || "104") + "&serial=" + encodeURIComponent(theSerial));
  
          
          const devicePackages = deviceMessages["packages"].map(item => ({
            name: item.package_name,
            date: item.last_update,
            current: item.current_version,
            destination: item.destination_version,
            id: item.id,
            name_issue_type:item.name_issue_type
          }));
  
          setPackages(devicePackages);
          setShowRemoteSupport(shouldShowRemoteSupportSection(devicePackages));

          setLoaded(true);
          loadIssues(theSerial, "hw");
          loadUsageTimeline(theSerial);
          loadLicenses(theSerial);
  
       }
      }
  
      fetchGetDevice(serial);
    };

  const loadUsageTimeline = (serial) => {
    async function fetchUsageTimeline(theSerial) {
      const usageData = await load_usage_timeline(token, theSerial);
      if (usageData === "INVALID") {
        navigate("/");
        return;
      }

      const syncs = Array.isArray(usageData?.syncs) ? usageData.syncs : [];
      setUsageSyncGroups(syncs);
      setExpandedUsageClusters(new Set());
    }

    fetchUsageTimeline(serial);
  };

  const loadContentsList = async () => {
    const contents = await get_contents_exclusive();
    if (contents && Array.isArray(contents)) {
      setContentsList(contents);
    } else {
      setContentsList([]);
    }
  };

  const handleAddLicense = () => {
    setSelectedContentId("");
    setSelectedEndDate("");
    loadContentsList();
    setShowLicenseModal(true);
  };

  const handleSaveLicense = async () => {
    if (!selectedContentId || !selectedEndDate) {
      alert("Por favor selecciona un contenido y una fecha de terminación");
      return;
    }

    const result = await add_license_stem(serialInput, selectedContentId, selectedEndDate);
    if (result === "INVALID") {
      navigate("/");
    } else if (result && result.error) {
      alert("Error: " + result.error);
    } else {
      setShowLicenseModal(false);
      loadLicenses(serialInput);
      alert("Licencia agregada correctamente");
    }
  };

  const handleEditLicense = (license) => {
    setEditingLicense(license);
    // Convertir la fecha al formato YYYY-MM-DD para el input date
    let dateValue = '';
    if (license.end_date && license.end_date !== '0' && license.end_date !== 'VENCIDO') {
      try {
        const date = new Date(license.end_date);
        if (!isNaN(date.getTime())) {
          dateValue = date.toISOString().split('T')[0];
        }
      } catch (e) {
        // Si no se puede parsear, dejar vacío
      }
    }
    setSelectedEndDate(dateValue);
    setShowEditLicenseModal(true);
  };

  const handleSaveEditLicense = async () => {
    if (!editingLicense || !selectedEndDate) {
      alert("Por favor selecciona una fecha de terminación");
      return;
    }

    const result = await update_license_stem(serialInput, editingLicense.content_id, selectedEndDate);
    if (result === "INVALID") {
      navigate("/");
    } else if (result && result.error) {
      alert("Error: " + result.error);
    } else {
      setShowEditLicenseModal(false);
      setEditingLicense(null);
      loadLicenses(serialInput);
      alert("Fecha de licencia actualizada correctamente");
    }
  };

  const handleDeleteLicense = async (license) => {
    if (!window.confirm(`¿Estás seguro de eliminar la licencia de "${license.content_name || license.content_id}"?`)) {
      return;
    }

    const result = await delete_license_stem(serialInput, license.content_id);
    if (result === "INVALID") {
      navigate("/");
    } else if (result && result.error) {
      alert("Error: " + result.error);
    } else {
      loadLicenses(serialInput);
      alert("Licencia eliminada correctamente");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === '0' || dateString === 'VENCIDO') {
      return dateString;
    }
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (e) {
      return dateString;
    }
  };


    const loadIssues = (serial, themode) => {
  
   
      async function fetchLoadIssues(theSerial, themode) {
        
      
        const deviceMessages = await load_issues(token, theSerial, themode);
        if (deviceMessages==="INVALID"){
          navigate("/");
        }else{
  
         
          const deviceIssues = deviceMessages["issues"].map((item, index) => ({
            comment: item.comment,
            date: item.date,
            usr_name: item.usr_name,
            id: item.id,
            name_issue_type:item.name_issue_type, 
            issue_type: Number(item.issue_type ?? 0) === 1 ? 1 : 0,
            status: Number(item.status), 
            canal:item.canal, 
            typology: item.typology ? JSON.parse(item.typology) : [],
            persona_contacto: item.persona_contacto,
            CAS_status: item.CAS_status,
            index: index
  
          }));
  
          
          setIssues(deviceIssues);
          setLoaded(true);
  
       }
      }
  
      fetchLoadIssues(serial, themode);
    };
    

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleFindBt(serialInput);
    }
  };

  const loadannotation = (indexAnnotation) => {
    const ticket = listofissues.find(
      (t) => t.id === indexAnnotation || Number(t.id) === Number(indexAnnotation)
    );
    openIssuePanel(indexAnnotation, ticket ? ticket.issue_type : 0);
    setCaseIdInUrl(indexAnnotation);
  };


  //--------------------- LINKING ELEMENTS
  const creatNewAnnotation =(issue_type = 0) =>{
    if (Number(issue_type) === 0 && !canCreateSupportTicket(permission)) {
      alert('No tienes permiso para crear tickets de soporte.');
      return;
    }
    if (Number(issue_type) === 1 && !canCreateTrainingTicket(permission)) {
      alert('No tienes permiso para crear tickets de formación.');
      return;
    }

        async function fetchcreateNew() {
          const newAnnotationId = await save_new_issue(token,serialInput,mode,usr_id,1, issue_type);
          if (newAnnotationId==="INVALID"){
            navigate("/");
          }else if (newAnnotationId==="FAILED" || newAnnotationId==="FORBIDDEN"){
            alert(newAnnotationId==="FORBIDDEN"
              ? "No tienes permiso para crear este tipo de ticket."
              : "No se pudo crear.");
          }else {
                openIssuePanel(newAnnotationId, issue_type);
                setCaseIdInUrl(newAnnotationId);
          }
        }

        fetchcreateNew();
  }

const getStatusText = (status) =>{
  switch (status){
    case 0:
      return ("Cerrado");
    case 1:
      return ("Abierto");
    case 2:
      return ("En observación");
  }
}

const filteredIssues = listofissues.filter((anno) => {
  if (ticketTypeFilter === 'all') return true;
  if (ticketTypeFilter === 'training') return Number(anno.issue_type) === 1;
  return Number(anno.issue_type) !== 1;
});

const ticketPassesFilter = (anno) => {
  if (ticketTypeFilter === 'all') return true;
  if (ticketTypeFilter === 'training') return Number(anno.issue_type) === 1;
  return Number(anno.issue_type) !== 1;
};

const formatHoursLabel = (value) => {
  const hours = Number(value ?? 0);
  if (!Number.isFinite(hours)) {
    return '0.00';
  }
  return hours.toFixed(2);
};

const toSortableTimestamp = (value) => {
  const t = Date.parse(value ?? '');
  return Number.isFinite(t) ? t : 0;
};

const toggleUsageCluster = (clusterId) => {
  setExpandedUsageClusters((prev) => {
    const next = new Set(prev);
    if (next.has(clusterId)) {
      next.delete(clusterId);
    } else {
      next.add(clusterId);
    }
    return next;
  });
};

const sortedTimelineItems = [
  ...listofissues.map((anno) => ({
    timeline_type: 'ticket',
    event_date: anno.date,
    payload: anno,
  })),
  ...usageSyncGroups.map((group, index) => ({
    timeline_type: 'usage_group',
    event_date: group.event_date,
    payload: { ...group, _index: index },
  })),
].sort((a, b) => toSortableTimestamp(b.event_date) - toSortableTimestamp(a.event_date));

const clusteredTimeline = (() => {
  const result = [];
  let currentClusterGroups = [];
  let clusterIndex = 0;

  const flushCluster = () => {
    if (currentClusterGroups.length === 0) {
      return;
    }

    const sessionCount = currentClusterGroups.reduce((sum, group) => {
      const sessions = Array.isArray(group.sessions) ? group.sessions : [];
      return sum + sessions.length;
    }, 0);

    result.push({
      timeline_type: 'session_cluster',
      cluster_id: `usage-cluster-${clusterIndex}`,
      event_date: currentClusterGroups[0].event_date,
      sessionCount,
      groups: currentClusterGroups,
    });

    clusterIndex += 1;
    currentClusterGroups = [];
  };

  sortedTimelineItems.forEach((item) => {
    if (item.timeline_type === 'usage_group') {
      currentClusterGroups.push(item.payload);
      return;
    }

    flushCluster();
    if (item.timeline_type === 'ticket' && ticketPassesFilter(item.payload)) {
      result.push(item);
    }
  });

  flushCluster();
  return result;
})();


  return (
    <div className={`container-flex px-4${loaded ? '' : ' mt-4'}`}> 
    
    {!loaded?
    (
        <motion.div
          key="form" // clave única para identificar este bloque
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
        >
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
          <div className="text-center" style={{ width: '100%', maxWidth: '500px' }}>
            <h1 style={{ fontWeight: '800', fontSize: '2.5rem', background: 'linear-gradient(90deg, #6366f1, #06b6d4)', WebkitBackgroundClip: 'text', color: 'transparent' }}>
              ¡TOMi helpdesk!
            </h1>
            <p style={{ fontSize: '1.25rem', fontWeight: '500', color: '#333' }}>¿Encuentra por email registrado en TOMi o serial del dispositivo?</p>

            <div className="mt-4 px-3">
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Escribe email o serial..."
                value={serialInput}
                onChange={(e) => setserialInput(e.target.value)}
                onKeyDown={handleKeyDown}
                style={{
                  border: '2px solid #6366f1',
                  borderRadius: '0.75rem',
                  boxShadow: '0 0 0 0.1rem rgba(99, 102, 241, 0.25)',
                }}
              />

              <button
                className="btn btn-lg mt-4 px-5 text-white"
                type="button"
                onClick={() => serialInput && handleFindBt(serialInput)}
                style={{
                  backgroundColor: '#6366f1',
                  borderRadius: '999px',
                  fontWeight: '600',
                  boxShadow: '0 4px 14px rgba(99, 102, 241, 0.4)',
                }}
              >
                🐸 Buscar
              </button>
            </div>
          </div>
        </div>
</motion.div>
    ):
    (
      <>
        <motion.div
      key="loaded"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
                <div
              className="d-flex justify-content-between align-items-center px-4 py-3 mb-4 shadow-sm flex-wrap"
              style={{
                background: 'linear-gradient(90deg, #6366f1, #06b6d4)',
                color: 'white',
                borderRadius: '0 0 1rem 1rem',
              }}
            >
              <div className="d-flex align-items-center flex-wrap gap-2">
                {mode === "hw" ? (
                  <>
                    <i className="bi bi-cpu-fill me-2" style={{ fontSize: '1.5rem' }}></i>
                    <strong className="fs-5 me-3">{serialInput}</strong>
                  <span className="fw-bold me-2">{model}</span>
                  <span className="text-light me-3">({manufactured_date})</span>
                 
                  <span className="mx-2">|</span>
                  <span>Garantía: <strong>{warranty_covered}</strong></span>
                  <span className="mx-2">|</span>
                 
                  <a href={dasboard_link} target="_blank" className="btn btn-outline-light btn-sm">
                  📊 Ver estadísticas
                </a>
                  </>
                ) : (
                 <>
                    <div className="d-flex align-items-center">
                      {/* Ícono */}
                      <span style={{ fontSize: '1.5rem' }} className="me-3">🐸</span>

                      {/* Serial */}
                      <strong className="fs-5 me-3">{serialInput}</strong>

                      {/* Información del usuario */}
                      <div className="d-flex align-items-center">
                        <p className="mb-0 me-2"><strong>Nombre:</strong></p>
                        <a
                          href={`https://team.tomi.la/server/brevo/redirect_to_contact_profile.php?email=${email_url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-link p-0 text-decoration-underline"
                          style={{ color: '#89CFF0' }} // Un azul claro para buen contraste
                        >
                          {name}
                        </a>
                      </div>
                    </div>
                  </>
                )}
                
              </div>

              <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
                
                <button
                  className="btn btn-light btn-sm d-flex align-items-center"
                  style={{
                    borderRadius: '999px',
                    fontWeight: '600',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  }}
                  onClick={() => {
                    resetHelpdeskState();
                    navigate('/helpdesk', { replace: true });
                  }}
                >
                  <i className="bi bi-x-circle me-2"></i> Cerrar
                </button>
              </div>
            </div>
      </motion.div>

          {!updatingAnnotation?(
              <motion.div
                key="loaded"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
        {mode==="sw"?
        (
            <User_header name={name} FrogedId={FrogedId} ></User_header>
        ):
        (
            <Device_header name={name} 
              packages={packages} 
              permission={permission} 
              token={token} 
              onRefresh={() => handleFindBtHW(serialInput)}
              warranty_covered={warranty_covered}
              model={model}
              dasboard_link={dasboard_link}
              manufactured_date={manufactured_date}
              item_status={item_status}
              serial_number={serialInput}
              licenses={licenses}
              onEditLicense={handleEditLicense}
              onDeleteLicense={handleDeleteLicense}
              onAddLicense={handleAddLicense}
              formatDate={formatDate}
              showRemoteSupport={Number(permission) === 1 && showRemoteSupport}
            > 
          
            </Device_header>
        )

          }

          {showLicenseModal && (
            <div
              className="modal show d-block"
              tabIndex="-1"
              style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setShowLicenseModal(false);
                }
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                    <h5 className="modal-title">Agregar Nueva Licencia</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowLicenseModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Contenido</label>
                      <select
                        className="form-select"
                        value={selectedContentId}
                        onChange={(e) => setSelectedContentId(e.target.value)}
                      >
                        <option value="">Selecciona un contenido</option>
                        {contentsList.map((content) => (
                          <option key={content.id} value={content.id}>
                            {content.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Fecha de Terminación</label>
                      <input
                        type="date"
                        className="form-control"
                        value={selectedEndDate}
                        onChange={(e) => setSelectedEndDate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowLicenseModal(false)}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSaveLicense}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showEditLicenseModal && editingLicense && (
            <div
              className="modal show d-block"
              tabIndex="-1"
              style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setShowEditLicenseModal(false);
                  setEditingLicense(null);
                }
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                    <h5 className="modal-title">Editar Fecha de Licencia</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowEditLicenseModal(false);
                        setEditingLicense(null);
                      }}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Contenido</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingLicense.content_name || editingLicense.content_id || 'N/A'}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Fecha de Terminación</label>
                      <input
                        type="date"
                        className="form-control"
                        value={selectedEndDate}
                        onChange={(e) => setSelectedEndDate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowEditLicenseModal(false);
                        setEditingLicense(null);
                      }}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSaveEditLicense}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

                    <div className="annotations-list mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <h3 className="mb-0">Timeline del dispositivo</h3>
                        <div className="btn-group ticket-type-filters" role="group" aria-label="Filtrar tickets">
                          <button
                            type="button"
                            className={`btn btn-sm ${ticketTypeFilter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setTicketTypeFilter('all')}
                          >
                            Todos
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${ticketTypeFilter === 'support' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setTicketTypeFilter('support')}
                          >
                            Soporte
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${ticketTypeFilter === 'training' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setTicketTypeFilter('training')}
                          >
                            Formación
                          </button>
                        </div>
                      </div>
                      {clusteredTimeline.length > 0 ? (
                        clusteredTimeline.map((item) => {
                          if (item.timeline_type === 'session_cluster') {
                            const isExpanded = expandedUsageClusters.has(item.cluster_id);
                            return (
                              <div key={item.cluster_id} className="usage-timeline-cluster mb-2">
                                <button
                                  type="button"
                                  className="usage-timeline-cluster-toggle"
                                  onClick={() => toggleUsageCluster(item.cluster_id)}
                                  aria-expanded={isExpanded}
                                >
                                  <i className={`bi bi-chevron-${isExpanded ? 'down' : 'right'} me-1`} />
                                  {item.sessionCount} sesiones
                                </button>
                                {isExpanded ? (
                                  <div className="usage-timeline-cluster-body">
                                    {item.groups.map((group) => {
                                      const sessions = Array.isArray(group.sessions) ? group.sessions : [];
                                      return (
                                        <div
                                          key={`usage-group-${group._index}-${group.event_date}`}
                                          className="usage-timeline-group"
                                        >
                                          <div className="usage-timeline-row usage-timeline-row--sync">
                                            <span className="usage-timeline-label">Sync horas de uso:</span>{' '}
                                            {formatHoursLabel(group.hours)}hrs{' '}
                                            <span className="usage-timeline-label">Fecha:</span>{' '}
                                            {group.event_date}
                                          </div>
                                          {sessions.map((session, sessionIndex) => (
                                            <div
                                              key={`session-${group._index}-${sessionIndex}-${session.event_date}`}
                                              className="usage-timeline-row usage-timeline-row--session usage-timeline-row--nested"
                                            >
                                              <span className="usage-timeline-label">Sesión:</span>{' '}
                                              {formatHoursLabel(session.hours)}Hrs{' '}
                                              <span className="usage-timeline-label">fecha:</span>{' '}
                                              {session.event_date}
                                            </div>
                                          ))}
                                        </div>
                                      );
                                    })}
                                  </div>
                                ) : null}
                              </div>
                            );
                          }

                          const anno = item.payload;
                          return (
                          <div
                            key={anno.id}
                            className={`card mb-3 shadow-sm ${Number(anno.issue_type) === 1 ? 'ticket-card--training' : ''}`}
                            onClick={() => loadannotation(anno.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <div>
                                <small className="text-muted">
                                  #: {anno.id}  Por: {anno.usr_name} - {anno.date} <br/>
                                  Contacto: {anno.persona_contacto} - Canal: {anno.canal}
                                </small>
                              </div>
                          
                      
                            {anno.typology && anno.typology.length > 0 && (
                              <div className="d-flex flex-wrap gap-1"> 
                                {anno.typology.map((typo, index) => {
                                   const dynamicColor = getColorForId(parseInt(typo.typo_id));
                                  return (
                                  <span key={index} className="badge"
                                   style={{ backgroundColor: dynamicColor, cursor: 'pointer' }} >
                                    {typo.typology}
                                  </span>
                                )})}
                              </div>)
                            }

                            {/* Aquí se integra el mini status bar — solo tickets de soporte */}
                            {Number(anno.issue_type) !== 1 && parseInt(anno.CAS_status) !=0 && (
                                    <MiniStatusBar
                                      currentStep={parseInt(anno.CAS_status)} 
                                      totalSteps={8} 
                                    />
                            )}
                              {Number(anno.issue_type) !== 1 && (
                              <span className={`badge ${anno.status === 0 ? 'bg-success' : (anno.status === 1 ? 'bg-danger' : 'bg-primary')}`}>
                                {getStatusText(anno.status)}
                              </span>
                              )}
                            </div>
                            
                          </div>
                          );
                        })
                      ) : (
                        <p className="text-muted">
                          {listofissues.length === 0 && usageSyncGroups.length === 0
                            ? 'No hay anotaciones para mostrar.'
                            : 'No hay tickets que coincidan con el filtro seleccionado.'}
                        </p>
                      )}

                    </div>

                {canCreateAnyTicket(permission) && (
                  canCreateSupportTicket(permission) ? (
               <Dropdown drop="up" className="position-fixed" style={{ bottom: '2rem', right: '2rem', zIndex: 1050 }}>
                  <Dropdown.Toggle
                    as="button"
                    className="btn btn-primary rounded-circle shadow-lg d-flex align-items-center justify-content-center"
                    style={{
                      width: '60px',
                      height: '60px',
                      border: 'none',
                      padding: 0,
                    }}
                    id="dropdown-new-ticket"
                  >
                    <i className="bi bi-plus-lg" style={{ fontSize: '1.5rem' }}></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => creatNewAnnotation(0)}>
                      Ticket de soporte
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => creatNewAnnotation(1)}>
                      Ticket de formación
                    </Dropdown.Item>
                  </Dropdown.Menu>
               </Dropdown>
                  ) : (
               <button
                  type="button"
                  className="btn btn-primary rounded-circle shadow-lg position-fixed d-flex align-items-center justify-content-center"
                  style={{
                    bottom: '2rem',
                    right: '2rem',
                    width: '60px',
                    height: '60px',
                    zIndex: 1050,
                  }}
                  title="Ticket de formación"
                  onClick={() => creatNewAnnotation(1)}
                >
                  <i className="bi bi-plus-lg" style={{ fontSize: '1.5rem' }}></i>
                </button>
                  )
                )}
                  </motion.div>
          ):(
          <motion.div
                key="loaded"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
            {activeIssueType === 1 ? (
            <Training_ticket_panel
              permission={permission}
              issue_updating_id={issue_updating_id}
              token={token}
              usr_id={usr_id}
              onCloseAnnotation={closeIssuePanel}
            />
            ) : (
            <Ticket_panel
              permission={permission}
              issue_updating_id={issue_updating_id}
              mode ={mode}
              serialInput={serialInput}
              token={token}
              usr_id={usr_id}
              onCloseAnnotation={closeIssuePanel}
            ></Ticket_panel>
            )}
          </motion.div>
           )}
  </>
    )}
      
    </div>
  );
};

export default Email_info;
